// Lightweight UI state shared across pages: drawer open/close,
// transient toasts. Mirrors the prototype shell.jsx StoreCtx subset
// that the v2 app actually uses (no run simulator — that lives in the
// real backend / mock API now).

import { create } from "zustand";

interface ToastMsg {
  id: number;
  msg: string;
}

interface UiState {
  aiGenOpen: boolean;
  playbookGenOpen: boolean;
  toast: ToastMsg | null;
  setAiGenOpen: (open: boolean) => void;
  setPlaybookGenOpen: (open: boolean) => void;
  showToast: (msg: string) => void;
  clearToast: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  aiGenOpen: false,
  playbookGenOpen: false,
  toast: null,
  setAiGenOpen: (open) => set({ aiGenOpen: open }),
  setPlaybookGenOpen: (open) => set({ playbookGenOpen: open }),
  showToast: (msg) => {
    const id = Date.now();
    set({ toast: { id, msg } });
    setTimeout(() => {
      set((s) => (s.toast?.id === id ? { toast: null } : s));
    }, 2400);
  },
  clearToast: () => set({ toast: null }),
}));
